import { useQuery } from '@tanstack/react-query';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';
import { useApiMutation } from '../hooks/useApiMutation';

export function useMessagingSettingsQuery() {
  return useQuery({ queryKey: queryKeys.messagingSettings.detail(), queryFn: () => portalApi.messagingSettings() });
}

const mergeSections = (settings, patch) =>
  Object.entries(patch).reduce(
    (acc, [section, values]) => ({ ...acc, [section]: { ...acc[section], ...values } }),
    settings || {}
  );

export function useUpdateMessagingSettings({ success = 'Inbox settings saved' } = {}) {
  return useApiMutation({
    mutationFn: (patch) => portalApi.updateMessagingSettings(patch),
    optimistic: (patch) => [
      {
        key: queryKeys.messagingSettings.detail(),
        update: (data) => ({ ...data, settings: mergeSections(data.settings, patch) })
      }
    ],
    invalidate: [queryKeys.messagingSettings.all],
    success,
    error: 'Could not save messaging settings'
  });
}
